/* eslint-disable */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index.js'
import axios from 'axios'

import bootstrap from 'bootstrap'
import { store } from './store'
  //���C�u�����̃C���|�[�g
import './components/js/userdata.js';
import './css/bootstrap.css';
import './css/volukatsu-common.css';
import './css/borakatsu-light.css';
import './css/borakatsu-textsize.css';
import './css/borakatsu-toggle.css';
import './css/all.min.css';
import { defineRule, configure } from 'vee-validate';
import { localize } from '@vee-validate/i18n';
import ja from '@vee-validate/i18n/dist/locale/ja.json';
//import AllRules from '@vee-validate/rules';
//Object.keys(AllRules).forEach((rule) => {
//  defineRule(rule, AllRules[rule]);
//});

import { Amplify } from "aws-amplify"
import awsconfig from './aws-exports.js'

import cookies from 'vue3-cookies'

configure({
   generateMessage: localize({ja,}),
});
localize('ja');

createApp(App).use(store).use(router).use(cookies).mount('#app')

Amplify.configure(awsconfig);
